module.exports = __webpack_public_path__ + "images/corners/Santa Fe.d948d00d539a284a04b9db253dcdba08.jpg";